export function toCurrency(numero) {
    const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    const numFormatado = formatter.format(numero);
    return numFormatado;
}